import { setCountAction } from "./_common";

const main = () => {
    if (document.querySelector('#page-search-station') === null) return;
    setCountAction();
}

export default main;
